<template>
  <div class="liked-box" :class="{liked: isLiked}" v-on:click.stop="toggleLike"></div>
</template>

<script>

export default {
  props: {
    imageId: Number
  },
  computed: {
    isLiked: function () {
      return this.$store.getters.isLiked(this.imageId)
    }
  },
  methods: {
    toggleLike: function () {
      if(this.isLiked) {
        this.$store.commit('removeLike', this.imageId)
      }
      else {
        this.$store.commit('addLike', this.imageId)
      }
      this.$emit('click', this.isLiked)
    }
  }

}
</script>

<style>
  .liked-box{
    background-image:url('../../assets/img/add.svg');
    background-repeat:no-repeat;
    background-size:contain;
    user-select: none;
    cursor:pointer;
    display:inline-block;
    width:21px;
    height:21px;
    transition:all 0.1s linear;
  }

  .liked-box.liked{
    background-image:url('../../assets/img/add-done.svg');
  }



  .liked-box:hover{
    background-image:url('../../assets/img/add-over.svg');
    transform:scale(1.1);
  }

  .liked-box.liked:hover{
    background-image:url('../../assets/img/add-done.svg');
  }

  .liked-box:active{
    transform:scale(1.2);
  }
</style>
